import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/carApplications/zxzxc_task/page',
    method: 'post',
    data,
  })
}

export async function approval(data) {
    return request({
      url: '/v2/carApplications/zxzxc_task/check',
      method: 'post',
      data,
    })
}